import type { LanguageCode } from '@common/translate/translate';
import { getLanguage } from '@common/translate/translate';

export function booleanAsJaNee(value: boolean | null): 'Ja' | 'Nee' | null {
    if (value === null) {
        return value;
    }

    return value ? 'Ja' : 'Nee';
}

export function concatOrNull(value: string | number | null | undefined, label: string): string | null {
    if (!value && value !== 0) {
        return null;
    }

    if (typeof value === 'number') {
        value = localeNlString(value);
    }

    return `${value} ${label}`;
}

export function localeNlStringOrNull(number?: number | null, options?: Intl.NumberFormatOptions): string | null {
    if (number === null || typeof number === 'undefined') {
        return null;
    }

    return localeNlString(number, options);
}

export function localeNlString(number: number, options?: Intl.NumberFormatOptions): string {
    return number.toLocaleString('nl-NL', options);
}

export function joinArrayWithConjunction(list: string[], languageCode: LanguageCode = 'nl'): string {
    if (list.length > 1) {
        const lastItem = list.pop();

        return `${list.join(', ')} ${getLanguage(languageCode).common.and} ${lastItem}`;
    } else if (list.length === 1) {
        return list[0];
    }

    return '';
}
